import { Balloon, Heart, Text } from '@doda/io-react/common';
import styles from './index.module.scss';

export const MatchingBalloon = () => {
  return (
    <Balloon
      color="turquoise"
      size="M"
      shadow="blue"
      tailPosition="left"
      className={styles['jobCard-matchingBalloon']}
    >
      <Heart color="yellow" size="M" />
      <Text
        as="p"
        color="white"
        size="16"
        weight="bold"
        className={styles['jobCard-matchingBalloon__message']}
      >
        マッチング成立！
        <Text as="span" color="white" size="12" weight="bold">
          応募をお待ちしています。
        </Text>
      </Text>
    </Balloon>
  );
};
